import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';

export const Actionable = ({
  onClick,
  title,
  display = 'block',
  children,
  className
}) => {
  const styles = {
    main: css`
      display: ${display};
      cursor: pointer;
      margin: 0;
      padding: 0;
      border: 0;
      outline: 0;
      background: transparent;
      color: currentColor;
      width: ${display === 'block' ? '100%' : 'auto'};
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      -webkit-tap-highlight-color: transparent;
    `
  };

  return (
    <button
      className={className}
      type="button"
      onClick={onClick}
      css={styles.main}
      title={title}
      aria-label={title}
    >
      {children}
    </button>
  );
};

Actionable.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string,
  display: PropTypes.string,
  children: PropTypes.node.isRequired
};
